module.exports = __webpack_public_path__ + "static/media/padjajaran_logo.cff0f5ba.png";